<template>
    <b-col lg="10">
      <b-form-group class="text-left"
                    label-class="font-weight-bold pt-0"
                    :label="label">
        <span class="small">{{comment}}</span>
        <b-form-textarea
            v-if="rows > 1"
            id="textarea"
            v-model="text"
            :placeholder="placeholder"
            :rows="rows"
            max-rows="4"
            @input="changedText"
        ></b-form-textarea>
        <b-input v-if="rows == 1"
                 v-model="text"
                 @input="changedText"
                 :placeholder="placeholder"/>
      </b-form-group>
    </b-col>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'FormTextEditor',
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    comment: {
      type: String,
      default: ''
    },
    directValue: {
      type: Object,
      default: () => {}
    },
    codeQuestion: {
      type: String,
      default: ''
    },
    rows: {
      type: Number,
      default: 6
    }
  },
  data () {
    return {
      text: ''
    }
  },
  watch: {
    value (val) {
      console.log('watch: value', val)
      this.text = val
    },
    directValue (val) {
      const point = val[this.codeQuestion]
      if (!_.isEmpty(point)) {
        console.log('watch: directValue', point)
        this.text = point
      }
    }
  },
  mounted () {
    console.log('mounted')
    const point = this.directValue[this.codeQuestion]
    if (!_.isEmpty(point) && this.text !== point) {
      console.log('watch: directValue', point)
      this.text = point
    }
  },
  beforeMount () {
    console.log('beforeMount')
  },
  methods: {
    changedText (val) {
      if (val && val.length > 0) {
        const item = {codeQuestion: this.codeQuestion, value: val}
        this.$emit('action-output', item)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/form/FormTextEditor.vue